import { render, staticRenderFns } from "./HostSection.vue?vue&type=template&id=04b95f70&scoped=true"
import script from "./HostSection.vue?vue&type=script&lang=js"
export * from "./HostSection.vue?vue&type=script&lang=js"
import style0 from "./HostSection.vue?vue&type=style&index=0&id=04b95f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b95f70",
  null
  
)

export default component.exports